/**
 * Measurement Profile Queries
 */

import gql from 'graphql-tag'

export const getFitProfileQuery = gql`
  query getUserFitProfiles {
    fitProfiles: getUserFitProfiles {
      id
      role
      profileOwner: profile_owner
      firstName: first_name
      lastName: last_name
      unit
      gender
      height
      weight
      unit
      completedAt: completed_at
      chest
      outseam
      waist
      low_hips
      neck
      inside_leg_height
      upper_arm_length
    }
  }
`

export const updateProfileNameMutation = gql`
  mutation updateFitProfileName($id: Int!, $firstName: String!, $lastName: String!) {
    updateFitProfileName(id: $id, firstName: $firstName, lastName: $lastName) {
      message
    }
  }
`

export const deleteProfileMutation = gql`
  mutation deleteFitProfile($id: Int!) {
    deleteFitProfile(id: $id) {
      message
    }
  }
`


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/components/MeasurementProfile/data.ts